import * as Animate from "react-reveal";

const reasons = [
  {
    number: "01",
    title: "Teach ambitious learners",
    desc:
      "Turn practical industry knowledge into learning that people can use.",
  },
  {
    number: "02",
    title: "Join a professional network",
    desc:
      "Build alongside practitioners, coaches and the wider Utiva faculty community.",
  },
  {
    number: "03",
    title: "Grow your influence",
    desc:
      "Share current tools, decisions and context with the next generation of talent.",
  },
  {
    number: "04",
    title: "Shape real project work",
    desc:
      "Help learners connect concepts to practical projects and workplace decisions.",
  },
  {
    number: "05",
    title: "Reach more programmes",
    desc:
      "Contribute across relevant Utiva learning experiences as opportunities become available.",
  },
  {
    number: "06",
    title: "Build meaningful impact",
    desc:
      "Help capable people gain confidence, evidence and access to opportunity.",
  },
];

const TrainerWhySection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Why teach with Utiva
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-xl tracking-[-0.03em] text-primary">
              Make your experience useful to someone coming next.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              The strongest trainers do more than deliver slides. They help
              learners see how knowledge works in real situations, practise it
              and improve.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((reason) => (
            <Animate.Fade bottom key={reason.number}>
              <article className="h-full rounded-2xl border border-hire-line p-7">
                <span className="w-9 h-9 rounded-lg bg-hire-tint-blue text-primary grid place-items-center font-poppins text-sm font-extrabold mb-6">
                  {reason.number}
                </span>
                <h3 className="font-poppins font-extrabold text-xl text-primary mb-2.5">
                  {reason.title}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                  {reason.desc}
                </p>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainerWhySection;
